import React, { useState, useEffect } from 'react';
import { STORAGE_KEYS } from '../constants/storageKeys';
import { BASE_URL } from '../constants/config';
import { showToast } from '../components/Toast';
import AppShell from '../components/AppShell';
import Modal from '../components/Modal';

const GU_NUMS = ['શૂન્ય','એક','બે','ત્રણ','ચાર','પાંચ','છ','સાત','આઠ','નવ','દસ','અગિયાર','બાર','તેર','ચૌદ','પંદર','સોળ','સત્તર','અઢાર','ઓગણીસ','વીસ','એકવીસ','બાવીસ','તેવીસ','ચોવીસ','પચ્ચીસ','છવ્વીસ','સત્તાવીસ','અઠ્ઠાવીસ','ઓગણત્રીસ','ત્રીસ','એકત્રીસ','બત્રીસ','તેત્રીસ','ચોત્રીસ','પાંત્રીસ','છત્રીસ','સાડત્રીસ','આડત્રીસ','ઓગણચાળીસ','ચાળીસ','એકતાળીસ','બેતાળીસ','તેતાળીસ','ચુમ્માળીસ','પિસ્તાળીસ','છેતાળીસ','સુડતાળીસ','અડતાળીસ','ઓગણપચાસ','પચાસ','એકાવન','બાવન','ત્રેપન','ચોપન','પંચાવન','છપ્પન','સત્તાવન','અઠ્ઠાવન','ઓગણસાઠ','સાઠ','એકસઠ','બાસઠ','ત્રેસઠ','ચોસઠ','પાંસઠ','છાસઠ','સડસઠ','અડસઠ','ઓગણસિત્તેર','સિત્તેર','એકોતેર','બોતેર','તે્યોતેર','ચુ્યોતેર','પંચોતેર','છોતેર','સિત્યોતેર','ઈઠ્યોતેર','ઓગણએસી','એસી','એક્યાસી','બ્યાસી','ત્ર્યાસી','ચોર્યાસી','પંચ્યાસી','છ્યાસી','સિત્યાસી','અઠ્યાસી','ઓગણનોવું','નેવું','એકાવણું','બાણું','ત્રેણું','ચોણું','પંચાણું','છન્નું','સત્તાણું','અઠ્ઠાણું','નેવ્વાણું'];

const inGujarati = (n) => {
  if (n === 0) return 'શૂન્ય';
  let r = '';
  if (n >= 10000000) { r += GU_NUMS[Math.floor(n/10000000)] + ' કરોડ '; n %= 10000000; }
  if (n >= 100000) { r += GU_NUMS[Math.floor(n/100000)] + ' લાખ '; n %= 100000; }
  if (n >= 1000) { r += GU_NUMS[Math.floor(n/1000)] + ' હજાર '; n %= 1000; }
  if (n >= 100) { r += GU_NUMS[Math.floor(n/100)] + ' સો '; n %= 100; }
  if (n > 0) r += GU_NUMS[n];
  return r.trim();
};

const amountToWords = (amount) => {
  if (!amount) return '';
  const rupees = Math.floor(amount);
  const paise = Math.round((amount - rupees) * 100);
  let result = inGujarati(rupees) + ' રૂપિયા';
  if (paise > 0) result += ' અને ' + inGujarati(paise) + ' પૈસા';
  return result + ' માત્ર';
};

const formatINR = (v) => v == null ? '' : v.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
const todayISO = () => new Date().toISOString().slice(0, 10);

const EmpCreditFormScreen = ({ params, onBack }) => {
  const [form, setForm] = useState({ EMPID: 0, Date: todayISO(), Amount: 0 });
  const [amountText, setAmountText] = useState('');
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [empLoading, setEmpLoading] = useState(false);
  const [empModalVisible, setEmpModalVisible] = useState(false);
  const [selectedEmpName, setSelectedEmpName] = useState('');
  const getToken = () => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);

  useEffect(() => {
    // Prefer the employee passed via navigation params (the currently selected employee)
    const paramEmpId = params?.empId;
    const paramEmpName = params?.empName;
    const storageId = localStorage.getItem(STORAGE_KEYS.EMP_ID);
    const storageName = localStorage.getItem(STORAGE_KEYS.USER_NAME);

    const resolvedId = paramEmpId || (storageId ? parseInt(storageId, 10) : null);
    const resolvedName = paramEmpName || storageName || (resolvedId ? `Employee ${resolvedId}` : '');

    if (resolvedId) {
      setForm(p => ({ ...p, EMPID: resolvedId }));
      setSelectedEmpName(resolvedName);
    }
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    setEmpLoading(true);
    try {
      const r = await fetch(`${BASE_URL}api/Employee/List`, { headers: { Authorization: `Bearer ${getToken()}` } });
      if (r.ok) setEmployees(await r.json());
    } catch (_) {} finally { setEmpLoading(false); }
  };

  const handleSave = async () => {
    if (!form.Amount || form.Amount <= 0) { showToast('Amount is required and must be greater than zero.', 'error'); return; }
    if (!form.EMPID) { showToast('Please select an employee.', 'error'); return; }
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/Expense/EMPACCredit/Add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({ ID: null, EMPID: form.EMPID, Date: new Date(form.Date).toISOString(), Amount: form.Amount }),
      });
      if (response.ok) { showToast('Credit added successfully.', 'success'); onBack(); }
      else {
        let msg = `Server error (${response.status})`;
        try { const d = await response.json(); if (d?.message) msg = d.message; } catch (_) {}
        showToast(msg, 'error');
      }
    } catch (_) { showToast('Failed to save credit.', 'error'); } finally { setLoading(false); }
  };

  return (
    <AppShell title="Add Credit" onBack={onBack}>
      <div style={{ padding: 16, paddingBottom: 40 }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          <div style={{ fontSize: 18, fontWeight: 700, textAlign: 'center', marginBottom: 20, color: '#333' }}>Add Credit</div>

          {/* Employee */}
          <div className="form-group">
            <label className="form-label">Select Employee</label>
            <div className="form-input-wrap">
              <input className="form-input form-input--readonly" readOnly value={selectedEmpName} placeholder="Tap to select employee" onClick={() => setEmpModalVisible(true)} />
              <span className="form-input-wrap__icon form-input-wrap__icon--clickable" onClick={() => setEmpModalVisible(true)}>▾</span>
            </div>
          </div>

          {/* Amount */}
          <div className="form-group">
            <label className="form-label">Amount</label>
            <div className="form-input-wrap">
              <input
                className="form-input"
                type="text"
                inputMode="decimal"
                placeholder="₹ 0.00"
                value={amountText}
                onChange={e => {
                  const raw = e.target.value.replace(/[^0-9.]/g, '');
                  const parts = raw.split('.');
                  const sanitized = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : raw;
                  setAmountText(sanitized);
                  const parsed = parseFloat(sanitized);
                  setForm(p => ({ ...p, Amount: isNaN(parsed) ? 0 : parsed }));
                }}
                style={{ paddingLeft: 36 }}
              />
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#666', fontSize: 15 }}>₹</span>
            </div>
            {form.Amount > 0 && (
              <>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a6e2e', marginTop: 4 }}>₹ {formatINR(form.Amount)}</div>
                <div style={{ fontSize: 11, color: '#555', fontStyle: 'italic' }}>{amountToWords(form.Amount)}</div>
              </>
            )}
          </div>

          {/* Date */}
          <div className="form-group">
            <label className="form-label">Date</label>
            <input
              className="form-input"
              type="date"
              value={form.Date}
              max={todayISO()}
              onChange={e => setForm(p => ({ ...p, Date: e.target.value }))}
            />
          </div>

          <button className="btn-primary btn-gold" onClick={handleSave} disabled={loading} style={{ marginTop: 8 }}>
            {loading ? <div className="spinner" /> : 'Save Credit'}
          </button>
        </div>
      </div>

      <Modal visible={empModalVisible} onDismiss={() => setEmpModalVisible(false)} title="Select Employee">
        {empLoading ? (
          <div className="loading-screen" style={{ minHeight: 100 }}><div className="spinner spinner--gold" /></div>
        ) : employees.map(emp => (
          <div key={emp.ID} className="list-item" onClick={() => {
            setForm(p => ({ ...p, EMPID: emp.ID }));
            setSelectedEmpName(emp.EmpName);
            setEmpModalVisible(false);
          }}>
            <div className="list-item__text"><div className="list-item__title">{emp.EmpName}</div></div>
            {form.EMPID === emp.ID && <span className="list-item__check">✓</span>}
          </div>
        ))}
      </Modal>
    </AppShell>
  );
};

export default EmpCreditFormScreen;
